import styled from 'styled-components'

export const Conatiner = styled.main`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    font-size: 24px;
    font-weight: bold;
  }
`
